import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/state/app.state';
import { selectUser } from 'src/app/state/selectors/user.selectors';
import * as moment from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { ReporteriaService } from 'src/app/services/convenio/reporteria.service';

@Component({
  selector: 'app-acta-falta',
  templateUrl: './acta-falta.component.html',
  styleUrls: ['./acta-falta.component.scss']
})
export class ActaFaltaComponent implements OnInit {
  @Input() turnosActivos: any;
  @Input() jefesTurno:any;
  @Input() cobradores:any;
  caseta:number;
  formBusqueda:FormGroup;
  previewActaBase64:any = null;
  turnosNames = {
    1: 'NOCTURNO',
    2: 'MATUTINO',
    3: 'VESPERTINO'
  }
  rolUser: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    private store: Store<AppState>,
    private reporteService:ReporteriaService,
    private ngxUiLoaderService:NgxUiLoaderService,
    private toastr:ToastrService,
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.getData();
  }

  createForm(){
    this.formBusqueda = this.formBuilder.group({
      fecha: ['', Validators.required], //fecha obligatoria
      turno: ['', Validators.required],
      motivoFalta : ['', Validators.required],
      cobrador : ['', Validators.required],
      testigo: ['',Validators.required],
      jefeTurno: ['', Validators.required],
      auxiliar: ['',Validators.required]
    });

    // this.formBusqueda.get('fecha').setValue(moment().format('YYYY-MM-DD'));//fecha actual
  }


  async getData() {
    this.ngxUiLoaderService.start('1');
    this.caseta = this.getCasetaUser().id;
    this.ngxUiLoaderService.stop('1');
  }

 changeRolUserActa() { //Para las casetas como brisas y san blas las actas se desarrollan a diferentes roles (cobrador, intendencia etc-)
  this.rolUser = !this.rolUser;
 }

  getCasetaUser() {
    let casetaTroncal;
    this.store.select(selectUser).subscribe( usuario => { // Obtener info del usuario
      casetaTroncal = usuario.caseta_usuario.find(caseta => caseta.tipo === 1);// Obtener caseta troncal
    });

    return casetaTroncal;
  }

  getTurnos() {
   return  this.reporteService.getTurnos();
  }

  getCobradores(tipoUser:number) {
    return this.reporteService.getUsersTipo(tipoUser);
  }

  getJefesTurno(tipoUser:number){
    return this.reporteService.getUsersTipo(tipoUser);
  }

  previewPDF() {
    this.ngxUiLoaderService.start('preview');
    let form = {...this.formBusqueda.value, caseta: this.caseta, download: false};
    this.reporteService.getPreviewActa(1, form)//numero pagina , formData
    .then(data => {
         console.log(data);
         this.ngxUiLoaderService.stop('preview');
         this.previewActaBase64 = data;
    })
    .catch(error => {
      this.ngxUiLoaderService.stop('preview');
      this.toastr.error('Algo salio mál, favor de volver a intenter la descarga del PDF', `${error}`, { positionClass: 'toast-bottom-right' } )  
    });
  }

  downloadPDF() {

  }

  transformTextUpper(event) {
    this.formBusqueda.get(`${event.target.name}`).setValue(event.target.value.toUpperCase());
  }
}
